import React, { useState, useEffect } from "react";

import "./App.css";
import SearchIcon from "./search.svg";
import MovieCard from "./MovieCard.jsx";
import logo from "./media/linkedIn.svg";

const API_URL = "https://www.omdbapi.com/?apikey=c481a974";
const App = () => {
  const [movies, setMovies] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const searchMovies = async (title) => {
    const response = await fetch(`${API_URL}&s=${title}`);
    const data = await response.json();

    setMovies(data.Search);
  };
  useEffect(() => {
    searchMovies("Movie");
  }, []);
  const handleKeyDown = (event) => {
    console.log("User pressed: ", event.key);
    if (event.key === "Enter") {
      searchMovies(searchTerm);
    }
  };
  return (
    <div className="app">
      <h1>Dream Movies</h1>
      <a
        href="https://www.linkedin.com/in/mohammad-c/"
        target="_blank"
        rel="noreferrer"
      >
        <img className="linkedIn" src={logo} alt="Logo"></img>
      </a>
      <div className="search">
        <input
          placeholder="Search for movies"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <img
          src={SearchIcon}
          alt="Search"
          onClick={() => searchMovies(searchTerm)}
        ></img>
      </div>
      {movies?.length > 0 ? (
        <div className="container">
          {movies.map((movie) => (
            <MovieCard movie={movie}></MovieCard>
          ))}
        </div>
      ) : (
        <div className="empty">
          <h2>No Movies found</h2>
        </div>
      )}
    </div>
  );
};
export default App;
